//* * React Imports
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { handleLastLayout, handleLayout } from '../../store/layout';

const breakpoint = 1200;

export const useLayout = () => {
  // ** Hooks
  const dispatch = useDispatch();
  const store = useSelector((state) => state.layout);

  const setLayout = useCallback((value) => {
    dispatch(handleLayout(value));
  }, [dispatch]);

  const setLastLayout = useCallback((value) => {
    dispatch(handleLastLayout(value));
  }, [dispatch]);

  useEffect(() => {
    if (window.innerWidth < breakpoint) {
      setLayout('vertical');
    }

    window.addEventListener('resize', () => {
      if (
        window.innerWidth <= breakpoint
        && store.lastLayout !== 'vertical'
        && store.layout !== 'vertical'
      ) {
        setLayout('vertical');
      }
      if (
        window.innerWidth >= breakpoint
        && store.lastLayout !== store.layout
      ) {
        setLayout(store.lastLayout);
      }
    });
  }, [setLayout, store.lastLayout, store.layout]);

  return {
    layout: store.layout,
    setLayout,
    lastLayout: store.lastLayout,
    setLastLayout
  };
};
